import React from "react";
import PropTypes from "prop-types";
import Plus from "assets/icons/Plus";
import toast, { Toaster } from "react-hot-toast";

import "components/common/parentButton/parentbtn.scss";
import { useNavigate } from "react-router-dom";

const ParentButton = (props) => {
  const { text, path } = props;
  const navigate = useNavigate();

  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <button className="parentbtn" onClick={() => navigate(path)}>
        <span>
          <Plus style={{ fill: "white" }} width={15} />
        </span>
        {text}
      </button>
    </>
  );
};

ParentButton.propTypes = {
  text: PropTypes.any,
};

export default ParentButton;
